module.exports = __webpack_public_path__ + "img/ic-finance.1653bba2.png";